import { render, staticRenderFns } from "./reviewTagDisplay.vue?vue&type=template&id=3c6e1484&scoped=true"
import script from "./reviewTagDisplay.vue?vue&type=script&lang=js"
export * from "./reviewTagDisplay.vue?vue&type=script&lang=js"
import style0 from "./reviewTagDisplay.vue?vue&type=style&index=0&id=3c6e1484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6e1484",
  null
  
)

export default component.exports